/***************************************************************************/
"use client";
/***************************************************************************/

const ScreenHeaderTitle: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <h1
      {...props}
      className={["h3 ml-0 mr-0 mt-0 mb-0", className]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </h1>
  );
};

export { ScreenHeaderTitle };
